import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

// Which chart slice the user drilled into lives in the URL, not in card state.
// That is what lets a user open a meeting in the Workspace and press Back to
// land on the same insights page with the same popup already open.
export const DRILLDOWN_PARAM = "drilldown";

const parseDrilldown = (raw) => {
  if (!raw) return null;

  try {
    const payload = JSON.parse(raw);
    return payload?.name ? payload : null;
  } catch (error) {
    console.warn("Ignoring unreadable insights drilldown param:", error);
    return null;
  }
};

const useInsightsDrilldown = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get(DRILLDOWN_PARAM);
  const drilldown = useMemo(() => parseDrilldown(raw), [raw]);

  // Opening pushes a history entry, so the browser Back button closes the
  // popup instead of leaving the page.
  const openDrilldown = useCallback(
    (payload) => {
      if (!payload?.name) return;

      const next = new URLSearchParams(searchParams);
      next.set(DRILLDOWN_PARAM, JSON.stringify(payload));
      setSearchParams(next);
    },
    [searchParams, setSearchParams]
  );

  const closeDrilldown = useCallback(() => {
    const next = new URLSearchParams(searchParams);
    next.delete(DRILLDOWN_PARAM);
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return { drilldown, openDrilldown, closeDrilldown };
};

export default useInsightsDrilldown;
